import React, { useEffect } from "react";
import { useCalcularProductos } from "./../../../../Shared/Hooks/Custom.hooks";
import { Table, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Productos.component.scss";

const ProductosComponent = ({
  productos,
  hayCliente = false,
  clickCarrito,
  productosPedido = [],
}) => {
  const [productosCalculados, setProductos, setProducto] = useCalcularProductos(
    productos,
    productosPedido
  );

  useEffect(() => {
    setProductos(productos, productosPedido);
  }, [productos, productosPedido]);

  const handleInputChange = (e, posicion) => {
    const { value: cantidad } = e.target;

    if (cantidad <= 0) {
      return;
    }

    const nuevoProductos = [...productosCalculados];
    setProducto(nuevoProductos, posicion, cantidad);
  };

  const handleClickCarrito = () => {
    const productosCarrito = productosCalculados.filter((producto) => {
      const { Cantidad } = producto;
      return Cantidad > 0;
    });

    if (productosCarrito.length > 0) {
      clickCarrito(productosCarrito);
    }

    // if (producto.Cantidad > 0) {
    //   clickCarrito(producto);
    // }
  };

  return (
    <>
      {hayCliente ? (
        <Button
          variant="primary"
          className="btn__carrito-float"
          onClick={handleClickCarrito}
        >
          <FontAwesomeIcon icon={["fas", "shopping-cart"]} size="1x" />
        </Button>
      ) : null}
      <Table striped bordered={false} hover>
        <thead>
          <tr className="text-center text-primary font-weight-bold">
            <th scope="col">Producto</th>
            <th scope="col">Precio</th>
            <th scope="col">Cantidad</th>
          </tr>
        </thead>
        <tbody>
          {productosCalculados.map((producto, index) => {
            return (
              <tr key={index}>
                <td className="w-50 text-left">{producto.Descripcion}</td>
                <td className="w-25 text-center">
                  {producto.Precio_Formateado}
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="Cantidad"
                    placeholder="Cantidad..."
                    className="text-center"
                    value={producto.Cantidad}
                    disabled={!hayCliente}
                    onChange={(e) => {
                      handleInputChange(e, index);
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default ProductosComponent;
